import { StatUser } from '../statApi/UsersApi';
import IUserRoles from '../types/IUserRoles';

// eslint-disable-next-line
export default function hasAccess(userPermissions: any, action = ''): boolean {
  const divider = ':';

  const [entity, requestedAction] = action.split(divider);

  let permissionsObj;
  try {
    permissionsObj = JSON.parse(userPermissions);
  } catch (e) {
    permissionsObj = userPermissions;
  }

  return permissionsObj && permissionsObj[entity] ? permissionsObj[entity][requestedAction] : false;
}

const roleHasAction = (role: IUserRoles, action: string): boolean => {
  return Array.isArray(role?.actions) && role.actions.includes(action);
};

const isGlobalRole = (role: IUserRoles): boolean => {
  return !role?.companyId && !role?.companyCode;
};

export const hasAccessForCompany = (
  user: StatUser | null | undefined,
  action: string,
  company?: { companyId?: number | null; companyCode?: string | null },
): boolean => {
  const roles = user?.userRoles;
  const rolesWithActions = roles?.filter((role) => Array.isArray(role?.actions));

  if (rolesWithActions?.length) {
    return rolesWithActions.some((role) => {
      if (!roleHasAction(role, action)) {
        return false;
      }
      if (isGlobalRole(role)) {
        return true;
      }
      if (company?.companyId != null && role.companyId === company.companyId) {
        return true;
      }
      if (company?.companyCode && role.companyCode === company.companyCode) {
        return true;
      }
      return false;
    });
  }

  return hasAccess(user?.permissions, action);
};
